import { createRouter, createWebHistory } from 'vue-router'
import { useStore } from "@/store/user";

const routes = [
  {
    path: '/',
    name: 'home',
    redirect: { name: 'race' },
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/LoginView/LoginView'),
    meta: {
      requireAuth: false
    }
  },
  {
    path: '/race',
    name: 'race',
    component: () => import('@/views/RaceView/RaceView'),
    meta: {
      requireAuth: true
    }
  },
  {
    path: '/statistics',
    name: 'statistics',
    component: () => import('@/views/StatisticsView/StatisticsView'),
    meta: {
      requireAuth: true
    }
  },
  {
    path: '/student_certificate',
    name: 'student_certificate',
    component: () => import('@/views/StudentCertificateView/StudentCertificateView'),
    meta: {
      requireAuth: true
    }
  },
  {
    path: '/teacher_certificate',
    name: 'teacher_certificate',
    component: () => import('@/views/TeacherCertificateView/TeacherCertificateView'),
    meta: {
      requireAuth: true
    }
  },
  {
    path: '/department',
    name: 'department',
    component: () => import('@/views/DepartmentView/DepartmentView'),
    meta: {
      requireAuth: true
    }
  },
  {
    path: '/category',
    name: 'category',
    component: () => import('@/views/CategoryView/CategoryView'),
    meta: {
      requireAuth: true
    }
  },
  {
    path: '/student',
    name: 'student',
    component: () => import('@/views/StudentView/StudentView'),
    meta: {
      requireAuth: true
    }
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach((to, from, next) => {
  const userStore = useStore();
  if (to.meta.requireAuth && !userStore.isLogin) {
    if (sessionStorage.getItem('token')) {
      userStore.isLogin = true;
      userStore.token = sessionStorage.getItem('token');
      next();
    } else {
      next({ name: 'login' });
    }
  } else {
    next();
  }
})

export default router
